import React, { useState } from 'react';
import axios from 'axios';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import '../styles/ContactSection.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await axios.post(`${API}/contact`, formData);
      
      if (response.data) {
        setStatus({ 
          type: 'success', 
          message: 'Thank you for your message! We will get back to you soon.' 
        });
        setFormData({ name: '', email: '', phone: '', message: '' });
      }
    } catch (error) {
      console.error('Error submitting contact form:', error);
      setStatus({ 
        type: 'error', 
        message: 'Something went wrong. Please try again or contact us directly via email.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section section-padding">
      <div className="container">
        <div className="contact-header">
          <h2 className="heading-1">
            Get in <span className="accent-orange">Touch</span>
          </h2>
          <p className="body-large contact-intro">
            Ready to experience the power of pure Cordyceps militaris? Reach out to us for inquiries, bulk orders, or to learn more about our products.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon accent-orange">
                <Mail size={24} />
              </div>
              <div className="info-content">
                <h3 className="heading-3">Email</h3>
                <p className="body-regular">MUSHHRUSHH@GMAIL.COM</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon accent-orange">
                <Phone size={24} />
              </div>
              <div className="info-content">
                <h3 className="heading-3">Phone</h3>
                <p className="body-regular">+91 9145737191</p>
                <p className="body-regular">+91 9833890978</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon accent-orange">
                <MapPin size={24} />
              </div>
              <div className="info-content">
                <h3 className="heading-3">Location</h3>
                <p className="body-regular">Goa, India</p>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="Your name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email" className="form-label">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="your@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone" className="form-label">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
                placeholder="+91 your number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label">Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                className="form-textarea"
                placeholder="Tell us about your interest in Cordyceps..."
              ></textarea>
            </div>

            {status.message && (
              <div className={`status-message ${status.type}`}>
                {status.message}
              </div>
            )}

            <button 
              type="submit" 
              className="btn-primary btn-orange"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
              <Send size={16} style={{ marginLeft: '8px' }} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;